'use client';

import Link from 'next/link';
import { motion } from 'framer-motion';
import { useState } from 'react';
import { useRouter } from 'next/navigation';

import { Input } from '@/slw/shared/ui/input';
import { HeadPageDataType } from '@/slw/entities/home/home.model';

export function HeadPage({ data }: { data: HeadPageDataType }) {
  const text = data.headingTitle.split(' ');
  const [search, setSearch] = useState<string>('');
  const router = useRouter();

  const gotoSearchResult = () => {
    if (!search) return;

    router.push(`/search-results/all-year?keyword=${search.substring(0, 50)}`);
  };

  return (
    <section
      className='section-head-page bg-[url(/images/home/home-overlay.png)]
    bg-no-repeat bg-position-[center_center]'
    >
      <div
        className='inner max-w-[920px] min-h-[50vh] md:min-h-[76vh] px-[15px]
        mx-auto flex flex-col items-center gap-4 md:gap-8 pt-30 md:pt-40 pb-10'
      >
        <div
          className='text-center font-bold text-[2rem] md:text-[2.5rem] lg:text-[3rem] xl:text-[4rem]
        text-background'
        >
          <div className='whitespace-pre-line'>
            {text.map((el, i) => (
              <motion.span
                initial={{ opacity: 0 }}
                whileInView={{
                  opacity: 1,
                  x: 0, // Slide in to its original position
                  transition: {
                    duration: 0.8,
                    delay: i / 6, // Animation duration
                  },
                }}
                viewport={{ once: false }}
                key={i}
              >
                {el}{' '}
              </motion.span>
            ))}
          </div>
        </div>

        <div className='relative w-full px-1 md:px-0'>
          <form
            onSubmit={(event) => {
              event.preventDefault();
              gotoSearchResult();
            }}
          >
            <button type='submit' className='absolute p-3 top-1/2 -translate-y-1/2'>
              <img src='/images/common/ic-search.png' alt='' />
            </button>
            <Input
              className='h-[3rem] md:h-[4rem] px-10 rounded-2xl focus-visible:ring-0'
              type='text'
              placeholder='What are you looking for?'
              onChange={(e) => setSearch(e.target.value || '')}
              maxLength={50}
            />
          </form>
        </div>

        <div className='flex flex-wrap justify-center gap-4 md:gap-6'>
          {data.topPage.map((item, idx) => (
            <div
              key={idx}
              className='bg-primary-2/75 hover:bg-primary transition-all duration-500 rounded-2xl
          min-w-[100px] md:min-w-[196px] min-h-[100px] md:min-h-[142px] py-4 md:py-6'
            >
              <Link href={item.href} className='flex flex-col items-center justify-between h-full'>
                <img src={item.image} className='max-w-[70px] md:max-w-[unset]' alt='' />
                <span className='font-inter font-[600] text-background'>{item.title}</span>
              </Link>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
